import type { TaskLogKind } from '@interfaces/IScheduler';

// The log's words are shared with the mobile app (`describeLogEntry`); the
// timeline's dot colours are the web's.
export { describeLogEntry } from '@d-orca/shared/client/activities';

/** The dot-colour CSS-module class suffix for each log kind (`styles['dot_'+…]`). */
export const LOG_KIND_DOT: Record<TaskLogKind, string> = {
  status: 'dot_status',
  progress: 'dot_progress',
  location: 'dot_location',
  check: 'dot_check',
  // An amendment is about the same checklist a tick is.
  checklist: 'dot_check',
  comment: 'dot_comment',
  system: 'dot_system',
  stock: 'dot_stock',
};
